







































































































import { NormsServices } from '../../../norms/api/NormsServices';
import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import { RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper } from '../../../core/mixins';
import { addItemToLocalStorage, getItemFromLocalStorageParsed, getStateByNumber, PRIVILEGE_KEYS, VehicleStateChoices, vehicleStateOptions } from '../../../core/utils';
import { LastReportFilters } from '../../utils';
import { TypeFilterDate } from '../../../core/models/type-filter-date';
@Component({
    components: {
        
    }
})

export default class FilterByVehicleState extends Mixins(RootStoreHelper, NotificationStoreHelper, VehicleStoreHelper) {
    activeFilters: number[];
    menu: boolean = false;
    show: boolean = true;
    vehicleTypes: object = {
        "1": "Automovil",
        "2": "Camion",
        "3": "Cosechadora",
        "4": "Sembradora",
        "5": "Fumigadora",
        "6": "Forestal"
    }
    vehicleStates: VehicleStateChoices = vehicleStateOptions;
    selectedFilters: LastReportFilters = {
        vehicleTypes: [],
        vehicleStates: [],
        filterWithRecentActivity: false,
        filtersWithLoad: false
    }
    parseVehicleState: Function = getStateByNumber;

    getLastReportFilters(){
        return this.selectedFilters
    }

     get isLastReportFilter(){
        return this.$_getFilterDate === TypeFilterDate.TR;
    }



    get existActiveFilters(): boolean {
        return this.selectedFilters['vehicleTypes'].length > 0 || 
        this.selectedFilters['vehicleStates'].length > 0 || 
        this.selectedFilters['filterWithRecentActivity']
    }
    
    saveVehicleTypesInLocalStorage(vehicleTypes): void {
        addItemToLocalStorage('vehicle_types', vehicleTypes);
    }


    mounted() {
        this.assignVehicleTypes();
    }

    updateVehicleTypesFilter(vehicleTypeId: string): void {
        if (this.selectedFilters['vehicleTypes'].indexOf(Number(vehicleTypeId)) !== -1) {
            this.selectedFilters['vehicleTypes'] = this.selectedFilters['vehicleTypes'].filter((item: number) => item !== Number(vehicleTypeId));
        } else {
            this.selectedFilters['vehicleTypes'].push(Number(vehicleTypeId));
        }
        this.changedSelectedFilters();
    }

    updateVehicleStateFilter(vehicleStateIds: number[]):void{
        vehicleStateIds.forEach((vehicleStateId: number) => {
            if (this.selectedFilters['vehicleStates'].indexOf(vehicleStateId) !== -1) {
                this.selectedFilters['vehicleStates'] = this.selectedFilters['vehicleStates'].filter((item: number) => item !== vehicleStateId);
            } else {
                this.selectedFilters['vehicleStates'].push(vehicleStateId);
            }
        });

        // console.log("selectedFilters", this.selectedFilters);
        this.changedSelectedFilters();
    }

    updateFilterRecentActivity(): void {
        this.selectedFilters['filterWithRecentActivity'] = !this.selectedFilters['filterWithRecentActivity'];
        this.changedSelectedFilters();
    }

     get isMdpUser(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.MDP] == true;
    }

    updateFiltersWithLoad(){
        this.selectedFilters['filtersWithLoad'] = !this.selectedFilters['filtersWithLoad']
        this.changedSelectedFilters();
    }

    assignVehicleTypes(): void {
        NormsServices.getVehicleTypes(false).then((response) => {
            this.vehicleTypes = response.vehicle_types;
            this.saveVehicleTypesInLocalStorage(this.vehicleTypes);
        });
    }

    @Emit()
    changedSelectedFilters(): LastReportFilters {
        return this.selectedFilters;
    }

    open(): void {
        this.menu = true;
    }

    close(): void {
        this.menu = false;
    }
}
